"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _styledComponentsModifiers = require("styled-components-modifiers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MODIFIER_CONFIG = {
  error: ({
    theme
  }) => "\n    color: ".concat(theme.palette.primary[1], ";\n  "),
  success: ({
    theme
  }) => "\n    color: ".concat(theme.palette.primary[2], ";\n  "),
  warning: ({
    theme
  }) => "\n    color: ".concat(theme.palette.primary[3], ";\n  ")
};

const StatusText = _styledComponents.default.div.withConfig({
  displayName: "StatusText"
})(["font-family:SF Pro Display,sans-serif;font-size:", ";color:", ";flex-basis:100%;padding-top:0.25rem;", ";"], (0, _polished.rem)('14px'), props => props.theme.palette.label, (0, _styledComponentsModifiers.applyStyleModifiers)(MODIFIER_CONFIG));

var _default = StatusText;
exports.default = _default;